/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.conf.js > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/



import '@quasar/extras/mdi-v4/mdi-v4.css'

import '@quasar/extras/fontawesome-v5/fontawesome-v5.css'

import '@quasar/extras/themify/themify.css'

import '@quasar/extras/line-awesome/line-awesome.css'

import '@quasar/extras/roboto-font/roboto-font.css'

import '@quasar/extras/material-icons/material-icons.css'



import '@quasar/extras/animate/fadeIn.css'

import '@quasar/extras/animate/fadeOut.css'


// We load Quasar stylesheet file
import 'quasar/dist/quasar.sass'




import 'src/css/app.scss'


import Vue from 'vue'
import createApp from './app.js'




import qboot_BootgoogleAnalytics from 'boot/googleAnalytics'

import qboot_Bootsentry from 'boot/sentry'

import qboot_Booti18n from 'boot/i18n'

import qboot_Bootaxios from 'boot/axios'

import qboot_BootvueAuth from 'boot/vueAuth'

import qboot_Bootkanban from 'boot/kanban'

import qboot_Bootslider from 'boot/slider'

import qboot_Boothighcharts from 'boot/highcharts'

import qboot_Bootdatepicker from 'boot/datepicker'

import qboot_Bootnotify from 'boot/notify'

import qboot_Bootvmask from 'boot/v-mask'

import qboot_Bootrecaptcha from 'boot/recaptcha'

import qboot_Bootvuex from 'boot/vuex'












async function start () {
  const { app, store, router } = await createApp()

  

  
  let routeUnchanged = true
  const redirect = url => {
    routeUnchanged = false
    window.location.href = url
  }

  const urlPath = window.location.href.replace(window.location.origin, '')
  const bootFiles = [qboot_BootgoogleAnalytics,qboot_Bootsentry,qboot_Booti18n,qboot_Bootaxios,qboot_BootvueAuth,qboot_Bootkanban,qboot_Bootslider,qboot_Boothighcharts,qboot_Bootdatepicker,qboot_Bootnotify,qboot_Bootvmask,qboot_Bootrecaptcha,qboot_Bootvuex]

  for (let i = 0; routeUnchanged === true && i < bootFiles.length; i++) {
    if (typeof bootFiles[i] !== 'function') {
      continue
    }

    try {
      await bootFiles[i]({
        app,
        router,
        store,
        Vue,
        ssrContext: null,
        redirect,
        urlPath
      })
    }
    catch (err) {
      if (err && err.url) {
        window.location.href = err.url
        return
      }

      console.error('[Quasar] boot error:', err)
      return
    }
  }

  if (routeUnchanged === false) {
    return
  }
  

  

    

    

    new Vue(app)

    

  

}

start()
